// eslint-disable-next-line no-shadow
export enum ViewType {
	Concept = 'Concept',
	DataService = 'DataService',
	Dataset = 'Dataset',
	PublicService = 'PublicService',
	MappingTable = 'MappingTable',
	Unspecified = 'Unspecified'
}
